import React, { Component } from "react";
import { Link } from "react-router-dom";
import { debounce } from "lodash";
import swal from "sweetalert";

import api from 'services/api';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as CampaignsActions,
  Selectors as CampaignsSelectors,
} from "store/ducks/campaigns";

import { Access } from "common";
import { Form, Loading, Icon } from "components";
import { ImportProducts } from "./components";

const MAX_IMPORT_LENGTH = 1000;

class CampaignForm extends Component {
  state = {
    data: this.props.data,
    collapses: {
      interests: false,
      products: false,
    },
    products: [],
    addStoreProducts: false,
    removeStoreProducts: false,
    importing: false,
  };

  constructor(props) {
    super(props);

    const {
      getCampaignChannelsRequest,
      getCampaignStoresRequest,
      getCampaignProductTypesRequest,
      getCampaignSectionsRequest,
      getCampaignSubSectionsRequest,
    } = props;

    this.handleSearchChannel = debounce(getCampaignChannelsRequest, 300);
    this.handleSearchStore = debounce(getCampaignStoresRequest, 300);
    this.handleSearchProductType = debounce(
      getCampaignProductTypesRequest,
      300
    );
    this.handleSearchSection = debounce(getCampaignSectionsRequest, 300);
    this.handleSearchSubSection = debounce(getCampaignSubSectionsRequest, 300);
  }

  componentDidMount() {
    const {
      getCampaignChannelsRequest,
      getCampaignStoresRequest,
      getCampaignProductTypesRequest,
      getCampaignSectionsRequest,
    } = this.props;

    getCampaignChannelsRequest();
    getCampaignStoresRequest();
    getCampaignProductTypesRequest();
    getCampaignSectionsRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleToggleScore = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleChangeInput = (e) => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangeDate = (name, value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleFindChannel = (value) => {
    this.handleSearchChannel(value);
  };

  handleSelectChannels = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_channels: value,
          store_channels_all: false,
        },
      },
    });
  };

  handleFindStore = (value) => {
    this.handleSearchStore(value);
  };

  handleSelectStores = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_places: value,
          store_places_all: false,
        },
      },
    });
  };

  handleFindProductType = (value) => {
    this.handleSearchProductType(value);
  };

  handleSelectProductTypes = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_product_types: value,
          store_product_types_all: false,
        },
      },
    });
  };

  handleFindSection = (value) => {
    this.handleSearchSection(value);
  };

  handleSelectSections = async (value) => {
    const { data } = this.state;

    await this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_sections: value,
          store_sections_all: false,
        },
      },
    });
    this.handleFindSubSection("");
  };

  handleFindSubSection = (value) => {
    const { data } = this.state;

    !!data.extra_data.store_sections.length
      ? this.handleSearchSubSection(
          value,
          data.extra_data.store_sections[0].value
        )
      : this.handleSearchSubSection(value);
  };

  handleSelectSubSections = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_sub_sections: value,
          store_sub_sections_all: false,
        },
      },
    });
  };

  handleToggleCollapses = (name, e) => {
    e.preventDefault();
    const { collapses } = this.state;

    this.setState({ collapses: { ...collapses, [name]: !collapses[name] } });
  };

  handleToggleAddStoreProduct = () => {
    const { addStoreProducts } = this.state;

    this.setState({ addStoreProducts: !addStoreProducts });
  };

  handleToggleRemoveStoreProduct = () => {
    const { removeStoreProducts } = this.state;

    this.setState({ removeStoreProducts: !removeStoreProducts });
  };

  handleImportProducts = async (grid, name) => {
    const { data } = this.state;
    try {
      this.setState({ importing: true });
      const skus = grid
        .map((sku) => sku[0].value)
        .filter((sku) => sku !== null && sku !== "")
        .join(`&skus[]=`);

      const response = await api.get(
        `store/v2/products?per=1000&skus[]=${skus}`
      );
      const products = response.data.data;

      let newList = [
        ...data.extra_data[name],
        ...products
          .filter(
            (product) =>
              !data.extra_data[name]
                .map((item) => item.value)
                .includes(product.id)
          )
          .map((product) => {
            return {
              sku: product.attributes.sku,
              value: product.id,
              label: product.attributes.sku,
            };
          }),
      ];

      if (newList.length > MAX_IMPORT_LENGTH) {
        newList = newList.slice(0, MAX_IMPORT_LENGTH);

        swal(
          "Máximo 1000 produtos",
          "O limite máximo de produtos é 1000, todos os produtos que excederam o limite não foram importados.",
          "info"
        );
      }

      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: newList,
          },
        },
      });
    } catch (error) {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: [],
          },
        },
      });
    } finally {
      this.setState({ importing: false });
    }
  };

  render() {
    const {
      data,
      collapses,
      addStoreProducts,
      removeStoreProducts,
      products,
      importing,
    } = this.state;
    const {
      saving,
      channels,
      stores,
      productTypes,
      sections,
      subSections,
      onSubmit,
    } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Campanha de Pontos</h3>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.Input
            name="description"
            placeholder="descrição"
            value={data.description}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Multiplicador de Pontos (ex: 1,75)</Form.Label>
          <Form.Input
            name="multiplier"
            placeholder="multiplicador de pontos"
            value={data.multiplier}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>início</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.start_at}
              onChange={(value) => this.handleChangeDate("start_at", value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field>
          <Form.Label>fim</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.end_at}
              onChange={(value) => this.handleChangeDate("end_at", value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Canais</Form.Label>
          <Form.Select
            isMulti
            placeholder="Canais"
            noOptionsMessage={() => "Procurar canais"}
            options={channels.data}
            onInputChange={this.handleFindChannel}
            onChange={this.handleSelectChannels}
            value={data.extra_data.store_channels}
            isDisabled={!!Access.lockedChannel()}
          />
        </Form.Field>

        {!Access.lockedChannel() && (
          <Form.Field className="checkbox-field">
            <Form.Label>Todos os canais</Form.Label>
            <Form.Checkbox
              name="store_channels_all"
              checked={data.extra_data.store_channels_all}
              onChange={() => this.handleToggleExtra("store_channels_all")}
            />
          </Form.Field>
        )}

        <h1>{Access.lockedStore()}</h1>

        <Form.Field className="field-select">
          <Form.Label>Lojas</Form.Label>
          <Form.Select
            isMulti
            placeholder="Lojas"
            noOptionsMessage={() => "Procurar lojas"}
            options={stores.data}
            onInputChange={this.handleFindStore}
            onChange={this.handleSelectStores}
            value={data.extra_data.store_places}
            isDisabled={!!Access.lockedStore()}
          />
        </Form.Field>

        {!Access.lockedStore() && (
          <Form.Field className="checkbox-field">
            <Form.Label>Todos as lojas</Form.Label>
            <Form.Checkbox
              name="store_placeS_all"
              checked={data.extra_data.store_places_all}
              onChange={() => this.handleToggleExtra("store_places_all")}
            />
          </Form.Field>
        )}

        <div className="form-section">
          <h4 className="form-section-title">
            Seções/Produtos
            <button
              className="form-section-toggler"
              onClick={(e) => this.handleToggleCollapses("products", e)}
            >
              <Icon
                name={collapses.products ? "caret-up" : "caret-down"}
                prefix="fa"
              />
            </button>
          </h4>

          <div
            className={`form-section-collapse ${
              collapses.products ? "open" : ""
            }`}
          >
            <Form.Field className="field-select">
              <Form.Label>Tipos de produtos</Form.Label>
              <Form.Select
                isMulti
                placeholder="Tipos de produtos"
                noOptionsMessage={() => "Procurar tipos de produtos"}
                options={productTypes.data}
                onInputChange={this.handleFindProductType}
                onChange={this.handleSelectProductTypes}
                value={data.extra_data.store_product_types}
                isDisabled={!!Access.lockedProductType()}
              />
            </Form.Field>

            {!Access.lockedProductType() && (
              <Form.Field className="checkbox-field">
                <Form.Label>Todos os tipos de produto</Form.Label>
                <Form.Checkbox
                  checked={data.extra_data.store_product_types_all}
                  onChange={() =>
                    this.handleToggleExtra("store_product_types_all")
                  }
                />
              </Form.Field>
            )}

            <Form.Field className="field-select">
              <Form.Label>Seções</Form.Label>
              <Form.Select
                isMulti
                placeholder="Seções"
                noOptionsMessage={() => "Procurar seções"}
                options={sections.data}
                onInputChange={this.handleFindSection}
                onChange={this.handleSelectSections}
                value={data.extra_data.store_sections}
                isDisabled={!!Access.lockedSection()}
              />
            </Form.Field>

            {!Access.lockedSection() && (
              <Form.Field className="checkbox-field">
                <Form.Label>Todas as seções</Form.Label>
                <Form.Checkbox
                  checked={data.extra_data.store_sections_all}
                  onChange={() => this.handleToggleExtra("store_sections_all")}
                />
              </Form.Field>
            )}

            <Form.Field className="field-select">
              <Form.Label>Subseções</Form.Label>
              <Form.Select
                isMulti
                placeholder="Subseções"
                noOptionsMessage={() => "Procurar subseções"}
                options={subSections.data}
                onInputChange={this.handleFindSubSection}
                onChange={this.handleSelectSubSections}
                value={data.extra_data.store_sub_sections}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Todas as sub seções</Form.Label>
              <Form.Checkbox
                checked={data.extra_data.store_sub_sections_all}
                onChange={() =>
                  this.handleToggleExtra("store_sub_sections_all")
                }
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Remover produtos MDH</Form.Label>
              <Form.Checkbox
                checked={data.extra_data.remove_mdh}
                onChange={() => this.handleToggleExtra("remove_mdh")}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Somente Produtos MDH</Form.Label>
              <Form.Checkbox
                checked={data.extra_data.add_mdh}
                onChange={() => this.handleToggleExtra("add_mdh")}
              />
            </Form.Field>

            <Form.Field className="field-select">
              <Form.Label>Incluir itens na campanha (LMs)</Form.Label>
              <div className="row">
                <div className="col-md-10">
                  <Form.Select
                    isMulti
                    isDisabled={data.extra_data.all_products}
                    placeholder="Incluir itens na campanha (LMs)"
                    noOptionsMessage={() => "Procurar itens"}
                    options={products.data}
                    onInputChange={this.handleFindProduct}
                    onChange={this.handleSelectAddProduct}
                    value={data.extra_data.add_store_products}
                    className="limited-height"
                  />

                  <small className="characters">
                    {data.extra_data.add_store_products.length}/1000 produtos
                  </small>
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn-import-products"
                    onClick={this.handleToggleAddStoreProduct}
                    disabled={data.extra_data.all_products}
                  >
                    Importar
                  </button>
                </div>
              </div>

              {addStoreProducts && (
                <ImportProducts
                  name="add_store_products"
                  onImport={this.handleImportProducts}
                  loading={importing}
                />
              )}
            </Form.Field>

            <Form.Field className="field-select">
              <Form.Label>Excluir itens na campanha (LMs)</Form.Label>
              <div className="row">
                <div className="col-md-10">
                  <Form.Select
                    isMulti
                    isDisabled={data.extra_data.all_products}
                    placeholder="Excluir itens na campanha (LMs)"
                    noOptionsMessage={() => "Procurar itens"}
                    options={products.data}
                    onInputChange={this.handleFindProduct}
                    onChange={this.handleSelectRemoveProduct}
                    value={data.extra_data.remove_store_products}
                    className="limited-height"
                  />

                  <small className="characters">
                    {data.extra_data.remove_store_products.length}/1000 produtos
                  </small>
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn-import-products"
                    onClick={this.handleToggleRemoveStoreProduct}
                    disabled={data.extra_data.all_products}
                  >
                    Importar
                  </button>
                </div>
              </div>

              {removeStoreProducts && (
                <ImportProducts
                  name="remove_store_products"
                  onImport={this.handleImportProducts}
                  loading={importing}
                />
              )}
            </Form.Field>
          </div>
        </div>

        <Form.Field className="margin-top-30">
          <Form.Label>Observações</Form.Label>
          <Form.TextArea
            name="alias"
            placeholder="Observações específicas deste benefício, como restrições/limitações, acúmulo, sobreposição e etc."
            onChange={this.handleChangeInput}
            value={data.alias}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Enviar e-mail</Form.Label>
          <Form.Checkbox
            checked={data.extra_data.send_email}
            onChange={() => this.handleToggleExtra("send_email")}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/points/campaigns" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button
            className="button-save"
            onClick={onSubmit}
            disabled={saving}
          >
            {saving ? (
              <Loading type="btn" size="small" text="Salvando..." />
            ) : (
              "Salvar"
            )}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  channels: {
    ...state.campaigns.channels,
    data: CampaignsSelectors.channels(state.campaigns.channels.data),
  },
  stores: {
    ...state.campaigns.stores,
    data: CampaignsSelectors.stores(state.campaigns.stores.data),
  },
  productTypes: {
    ...state.campaigns.productTypes,
    data: CampaignsSelectors.productTypes(state.campaigns.productTypes.data),
  },
  sections: {
    ...state.campaigns.sections,
    data: CampaignsSelectors.sections(state.campaigns.sections.data),
  },
  subSections: {
    ...state.campaigns.subSections,
    data: CampaignsSelectors.subSections(state.campaigns.subSections.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(CampaignsActions, dispatch);

export default connect(mapState, mapActions)(CampaignForm);
